import Vue from 'vue';
import MyComponents from '~/components/my-components';
Vue.use(MyComponents);
